import { useAuth } from "components/utils/auth";
import { JobManagementApi } from "components/utils/openapi";
import { AppConfig, getDefaultOptions } from "core/AppConfig";
import { useMutation } from "react-query";

export const useUpdateSubmissionContent = () => {
  const { getToken } = useAuth();
  return useMutation(
    async ({
      body,
      submissionId,
      submissionContentId,
    }: {
      body: any;
      submissionId: string;
      submissionContentId: string;
    }) => {
      const { getConfiguration } = AppConfig();
      const api = new JobManagementApi(getConfiguration(await getToken()));
      return api.submissionControllerUpdateContent(
        body,
        submissionId,
        submissionContentId,
        getDefaultOptions(await getToken())
      );
    }
  );
};
